export const redirectToBillingType = 'company/REDIRECT_TO_BILLING';

export enum GetCompanyInfoActionTypes {
  request = 'user/GET_COMPANY_INFO/REQUEST',
  success = 'user/GET_COMPANY_INFO/SUCCESS',
  failure = 'user/GET_COMPANY_INFO/FAILURE',
  cancel = 'user/GET_COMPANY_INFO/CANCEL',
}
